module.exports = __webpack_public_path__ + "static/media/GAOFEN 6.5d7f526e.czml";